var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page.team) ? _c('div', {
    class: {
      'active': _vm.currentPage == 'team-content' || this.pageIsAutoScrolling
    },
    attrs: {
      "id": "team-content"
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__main reduced-width"
  }, [_c('div', {
    staticClass: "content content_team light-bg"
  }, [_c('div', {
    staticClass: "team"
  }, [_c('waterfall', {
    ref: "waterfall",
    attrs: {
      "line-gap": 380,
      "align": "center",
      "watch": _vm.persons
    }
  }, _vm._l((_vm.persons.item), function(person, index) {
    return (!person.$is_founder) ? _c('waterfall-slot', {
      key: person.$id,
      ref: person.$id,
      refInFor: true,
      class: [_vm.isCurrentPerson(person.$id) && _vm.popupOpened ? 'selected' : 'deselected', _vm.getPersonsCardSize(person.card_size.$size)],
      style: (_vm.checkCurrentPerson(person)),
      attrs: {
        "width": 330,
        "height": 330 * person.card_size.$size,
        "order": index
      }
    }, [_c('div', {
      staticClass: "person",
      on: {
        "click": function($event) {
          _vm.setCurrentPerson(person.$id)
        }
      }
    }, [_c('span', {
      staticClass: "person__back",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.resetCurrentPerson()
        }
      }
    }, [_c('span', {
      staticClass: "icon-arrow-left"
    }), _vm._v(" "), _c('span', {
      staticClass: "icon-exit"
    })]), _vm._v(" "), (person.background) ? _c('div', {
      staticClass: "person__photo",
      style: ({
        backgroundImage: 'url(' + person.background.$src + ')'
      })
    }, [(person.photo) ? _c('div', {
      staticClass: "person__photo-img",
      style: ({
        backgroundImage: 'url(' + person.photo.$src + ')'
      })
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "person__info"
    }, [_c('div', {
      staticClass: "person__name"
    }, [_vm._v("\n                    " + _vm._s(person.text.item.first_name) + " " + _vm._s(person.text.item.last_name) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "person__position"
    }, [_vm._v("\n                    " + _vm._s(person.text.item.position) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "person__content",
      domProps: {
        "innerHTML": _vm._s(person.text.item.text_content)
      }
    })])])]) : _vm._e()
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "team__contacts",
    domProps: {
      "innerHTML": _vm._s(_vm.page.team.text_contacts)
    }
  })])])])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0528ef7f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/TeamContent.vue
// module id = 180
// module chunks = 0